import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import PpcUsersList from './ppc-list'
import PpcSearch from './ppc-search'
import {getPpcManagementList} from '../../../../actions/ppc'
import PageTitle from '../../../common/page-title/index'
import ArrowButton from '../../../common/button-arrow';
import irelandApi from '../../../../irelandApi'
import FileDownload from 'react-file-download'

class PpcManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      dateFrom:    '',
      dateTo:      '',
      pageNumber:  1
    };
  }

  componentWillMount() {
    this.props.dispatch(getPpcManagementList());
  }

  handleInputChange = (e) => {
    this.setState({searchValue: e.target.value});
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };

  handleSearch = () => {
    const {searchValue, dateFrom, dateTo, pageNumber} = this.state;
    this.props.dispatch(getPpcManagementList(searchValue, dateFrom, dateTo, pageNumber));
  };

  handleClear = () => {
    this.setState({
      searchValue: '',
      dateFrom:    '',
      dateTo:      '',
      pageNumber:  1
    }, this.handleSearch);
  };

  handlePageChange = (page, size) => {
    this.handleSearch();
    this.setState({pageNumber: page});
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="ppc-management">
        <Row>
          <Col md={12}>
            <PageTitle className="pull-left">Prepaid card management</PageTitle>
          </Col>
        </Row>

        <Row className="mg-top-10">
          <Col md={12}>
            <PpcSearch
              searchValue={this.state.searchValue}
              dateFromValue={this.state.dateFrom}
              dateToValue={this.state.dateTo}
              onInputChange={this.handleInputChange}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onSearch={this.handleSearch}
              onClear={this.handleClear}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <PpcUsersList
              users={this.props.users}
              fetching={this.props.fetching}
              fetched={this.props.fetched}
              pagination={this.props.pagination}
              onPageChange={this.handlePageChange}
              currentPage={this.state.pageNumber}
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users:      state.ppc.management.list,
    pagination: state.ppc.management.paging,
    links: state.ppc.management.links,
    fetching:   state.ppc.fetching,
    fetched:    state.ppc.fetched
  };
};

export default connect(mapStateToProps)(PpcManagement);



// WEBPACK FOOTER //
// ./src/components/admin/ppc/management/index.jsx